import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import UpdatesSection from "./components/UpdatesSection";
import RankingSection from "./components/RankingSection";
import GenresSection from "./components/GenresSection";
import FeatureSection from "./components/FeatureSection";
import TestimonialsSection from "./components/TestimonialsSection";
import AboutSection from "./components/AboutSection";
import FaqSection from "./components/FaqSection";
import SubscribeSection from "./components/SubscribeSection";
import Footer from "./components/Footer";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "韩国漫画yy",
  url: "https://comtock.github.io/",
  description: "韩漫yy每日更新与追更提醒平台，热门韩漫最新章节第一时间同步。",
  sameAs: [],
};

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "韩国漫画yy",
  url: "https://comtock.github.io/",
  inLanguage: "zh-CN",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://comtock.github.io/?s={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

export default function Home() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <main className="w-full bg-background-50">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }} />

      <Navbar />
      <Hero />
      <UpdatesSection />
      <RankingSection />
      <GenresSection />
      <FeatureSection />
      <TestimonialsSection />
      <AboutSection />
      <FaqSection />
      <SubscribeSection />
      <Footer />

      {showTop && (
        <a
          href="#home"
          aria-label="回到顶部"
          className="fixed bottom-6 right-6 z-40 w-11 h-11 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-xl shadow-md hover:bg-primary-600 transition-colors cursor-pointer"
        >
          <i className="ri-arrow-up-line"></i>
        </a>
      )}
    </main>
  );
}